import { render, staticRenderFns } from "./reportSemester.vue?vue&type=template&id=564d2b84&scoped=true&"
import script from "./reportSemester.vue?vue&type=script&lang=js&"
export * from "./reportSemester.vue?vue&type=script&lang=js&"
import style0 from "./reportSemester.vue?vue&type=style&index=0&id=564d2b84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d2b84",
  null
  
)

component.options.__file = "reportSemester.vue"
export default component.exports